module.exports = __webpack_public_path__ + "static/media/copy.9498bf4b.svg";